import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import 'react-notifications/lib/notifications.css';
import '../../../styles/components/signup.css';
import {firebase} from '../../../firebase/firebase';
import { Link, withRouter } from 'react-router-dom';
import {NotificationContainer} from 'react-notifications';
import {ShowNotification} from '../../../components/HandleNotifications';
import axios from 'axios';
import Loader from '../../../components/loader';
import database from '../../../firebase/firebase';
import logo from '../../../images/logo.jpeg';
axios.defaults.headers.post.Accept = "application/json";
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Methods"] = "ET, POST, PUT, DELETE";
axios.defaults.headers["Access-Control-Allow-Headers"] = "Authorization";

class Signup extends Component {

    constructor(props){

        super(props);

        this.state = {
            showMessage: false,
            error: null,
            goLogin: false,
            showPassword: false,
            message: '' ,
            loader: false,
            password: '',
            user: {
                name: '',
                lastName: '',
                email: '',
                locationName: '-----',
                cv: '-----',
                career: '-----',
                expertise: '-----',
                phoneNumber: '-----',
                experience: '-----',
                existCv: false,
                aboutMe: '-----',
                id: ''
            }
        };

    }
    componentDidMount(){
        window.scrollTo(0,0)
    }
    clearInputs = ()=>{
        this.setState({password: '', user: {
            name: '',
            email: '',
            locationName: '',
            cv: false,
            career: '',
            expertise: '',
            phoneNumber: '',
            experience: '',
            lastName:'',
            existCv: false
        }})
    }
    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === "password"){
            this.setState({password: value})
        }else{
            this.setState(prevState => {
                let user = Object.assign({}, prevState.user);
                user[name] = value;       
                return { user };                           
            });
        }
    }   
    handleErrors = (error) => {
        let m =''
        switch (error.code) {
            case 'auth/invalid-email':
                m = 'Error en el correo';
                this.setState({message: 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.'});
                break;
            case 'auth/email-already-in-use':
                m = 'Correo en uso';
                this.setState({message: 'El correo que proporcionaste esta actualmente en uso, si ya tienes una cuenta por favor ',
                    goLogin: true});
                break;
            case 'auth/weak-password':
                m = 'La contraseña es muy corta';
                this.setState({message: 'La contraseña debe de ser de al menos seis caracteres, por favor introduce una nueva e intantalo de nuevo.', goLogin: false});
                break;
            default:
                m=error.code
                this.setState({message: error.message, goLogin: false});
                break;
        }
        return m;
    } 
    handleSubmit = () => {
        const {password} = this.state;
        let email = this.state.user.email;
        firebase.auth().createUserWithEmailAndPassword(email, password).then((user)=>{
            if(user){
                this.setState(prevState => ({
                    user : {
                        ...prevState.user,
                        id: user.user.uid
                    }
                }));
                axios.request({
                    url: "https://us-central1-universia-dev.cloudfunctions.net/type",
                    method: "POST",
                    data: {email: email, type: "student"},
                    crossDomain: true
                }).then(res => {
                    if(!!res.data.code){
                        let message = this.handleErrors(res.data);
                        this.setState({loader: false})
                        this.setState({showMessage : true, error : res.data.code});
                        ShowNotification('error', message, 'Algo salio mal');
                    }else{
                        this.setState({loader: false})
                        firebase.auth().currentUser.sendEmailVerification();
                        database.collection(`users`)
                        .doc(`${res.data}`)
                        .set(this.state.user, {merge: true}).then(()=>{
                            this.setState({showMessage : true, 
                            message: 'Se ha enviado un link de verificacion al correo proporcionado verificalo e ', 
                            goLogin: true});
                        }).then(()=>{
                            ShowNotification('success', 'Te registraste exitosamente', '¡Listo!');
                            this.clearInputs();
                        });
                    }
                })
            } 
        }).catch((err) => {
            if(err){
                let message = this.handleErrors(err);
                this.setState({showMessage : true, loader: false, error : err});
                ShowNotification('error', message, 'Algo salio mal');
            }
        })
    }
    emailValidation = () => {
        this.setState({loader : true});
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(re.test(this.state.user.email)){
            if(this.state.user.email.indexOf("@udlap.mx", this.state.user.email.length - "@udlap.mx".length) !== -1){
                this.handleSubmit()
            }else{
                this.setState({loader: false})
                this.setState({showMessage : true, message : "Solo pueden registrarse los alumnos y egresados de la UDLAP"});
                ShowNotification("warning", "Usa tu correo institucional. Ejemplo Pedro@udlap.mx", "Correo electronico no asociado");
            }
        }else{
            this.setState({loader: false})
            this.setState({showMessage : true, message : 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.'});
            ShowNotification("warning", "Ingresa un correo valido", "Correo electronico invalido");
        }
    }
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    render(){
        return(
            <div>
            {this.state.loader ?  <div className="loader"><Loader text={"Estamos creando tu cuenta ..."} active={this.state.loader}/></div> :
                <div className="container signup-page">
                    <Row>
                        <nav className="header nav bg-transparent">
                            <div className="nav-brand shadow center-brand" onClick={()=> {this.props.history.push('/')}}>
                                <div className="nav-title">
                                    <img src={logo} alt="main-logo" className="main-logo"/>
                                    <p className="powered">Powered by: <b>La pieza</b></p>
                                </div>
                            </div>
                        </nav>
                    </Row>
                    <Row className="card-container">
                        <Col className="signup-area no-float mx-auto" xs={10} sm={8} md={5} lg={5} xl={4}>
                            <div className="s-card">
                                <p className="sign-text">Registrar nuevo usuario</p>
                                <p className="s-title">Realiza tu registro para tener acceso a la plataforma.</p>
                                <label className="labels" htmlFor="name">Nombre</label>
                                <input className="inputs" value={this.state.user.name}
                                type="text" name="name" onChange={this.handleInputChange}/>
                                <label className="labels" htmlFor="name">Apellidos</label>
                                <input className="inputs" value={this.state.user.lastName}
                                type="text" name="lastName" onChange={this.handleInputChange}/>
                                <label className="labels" htmlFor="email">Correo electrónico institucional</label>
                                <input className="inputs" value={this.state.user.email}
                                type="email" name="email" onChange={this.handleInputChange}/>
                                <label className="labels" htmlFor="password">Contraseña</label>
                                <input className="inputs" value={this.state.password}
                                type={this.state.showPassword ? "text" : "password"} name="password" onChange={this.handleInputChange}/>
                                <div className="toggle-password-container-su">
                                    <input type="checkbox" className='toggle-password' 
                                    onClick={this.togglePassword} id="togglePassword"/>
                                    <label className="toggle-password-label-su" htmlFor="togglePassword">
                                        Mostrar contraseña
                                    </label>
                                </div>
                                <button type="button" className="account-create mx-auto" 
                                onClick={this.emailValidation}>Crear cuenta</button>
                                {this.state.showMessage ? 
                                <p className="go-login-a">{this.state.message}</p>:
                                null}
                                {!this.state.showMessage ? 
                                <p className="go-login">Si ya tienes una cuenta  
                                <Link className="login-link" to="/login">inicia sesión</Link> </p>:
                                null}
                                {this.state.goLogin ? <Link className="login-link-a" to="/login">inicia sesión</Link> : null}
                            </div>
                        </Col>
                    </Row>
                </div> }
                    <NotificationContainer />
            </div>
        )
    }
}
export default withRouter(Signup);